var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbandonedCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8 95.5C40.666 95.5 43.8 92.366 43.8 88.5C43.8 84.634 40.666 81.5 36.8 81.5C32.9341 81.5 29.8 84.634 29.8 88.5C29.8 92.366 32.9341 95.5 36.8 95.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 95.5C78.366 95.5 81.5 92.366 81.5 88.5C81.5 84.634 78.366 81.5 74.5 81.5C70.634 81.5 67.5 84.634 67.5 88.5C67.5 92.366 70.634 95.5 74.5 95.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5001 14.7C93.8001 13.8 92.7001 13.3 91.5001 13.3H25.4001L24.7001 8.6C24.0001 3.9 20.0001 0.5 15.2001 0.5H4.4001C2.3001 0.5 0.600098 2.2 0.600098 4.3C0.600098 6.4 2.3001 8.1 4.4001 8.1H15.2001C16.2001 8.1 17.0001 8.8 17.1001 9.7L25.8001 67.2C26.7001 73 31.6001 77.2 37.4001 77.2H79.0001C81.1001 77.2 82.8001 75.5 82.8001 73.4C82.8001 71.3 81.1001 69.6 79.0001 69.6H37.4001C35.4001 69.6 33.7001 68.1 33.3001 66.1L32.6001 61.6H83.7001C85.5001 61.6 87.1001 60.3 87.5001 58.5L95.3001 17.9C95.6001 16.7 95.3001 15.6 94.5001 14.7ZM80.6001 54H31.5001L26.5001 21H86.9001L80.6001 54Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4002 37.5L46.7002 42.2001C45.2002 43.7001 45.2002 46.1 46.7002 47.6C47.4002 48.3 48.4002 48.7001 49.4002 48.7001C50.4002 48.7001 51.4002 48.3 52.1002 47.6L56.8002 42.9001L61.5002 47.6C62.2002 48.3 63.2002 48.7001 64.2002 48.7001C65.2002 48.7001 66.2002 48.3 66.9002 47.6C68.4002 46.1 68.4002 43.7001 66.9002 42.2001L62.2002 37.5L66.9002 32.8C68.4002 31.3 68.4002 28.9 66.9002 27.4C65.4002 25.9 63.0002 25.9 61.5002 27.4L56.8002 32L52.1002 27.3C50.6002 25.8 48.2002 25.8 46.7002 27.3C45.2002 28.8 45.2002 31.2001 46.7002 32.7001L51.4002 37.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbandonedCart);
export default __webpack_public_path__ + "static/media/abandonedCart.7465c4d39249b452aff4e7ae35b6f17b.svg";
export { ForwardRef as ReactComponent };